import { useEffect, useState } from "react";

/**
 * Tracks whether the mobile side menu (in Header.tsx) is open.
 * Header broadcasts an `rt-mobile-nav` CustomEvent whenever its
 * `mobileOpen` state changes. Components that overlap with the
 * drawer (BottomNav, GroundMeNow, etc.) listen here to hide
 * themselves and give the menu the full screen.
 */
export function useMobileNavOpen() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail as { open?: boolean } | undefined;
      setOpen(!!detail?.open);
    };
    window.addEventListener("rt-mobile-nav", handler);
    return () => window.removeEventListener("rt-mobile-nav", handler);
  }, []);

  return open;
}
